import React from 'react';

interface Props {
  fillColor: string;
  className: string;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const AppleLogoIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 18 22"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-labelledby="appStoreLogo"
    aria-hidden="true"
  >
    <title id="appStoreLogo">Apple App Store Logo</title>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-16 -9)" fill={fillColor} id="Group-31">
        <g>
          <g>
            <g transform="translate(16 8.2)">
              <g>
                <g transform="translate(0 .8)">
                  <path d="M14.397039,11.8152375 C14.4174962,10.1980968 15.249879,8.70435124 16.602561,7.85733667 C15.7453384,6.6104005 14.3610206,5.84815965 12.86721,5.80055667 C11.295594,5.63253167 9.771993,6.7584 8.97111,6.7584 C8.154747,6.7584 6.921693,5.81724 5.593887,5.84506083 C3.84685122,5.90254963 2.25762298,6.88971003 1.407654,8.44536917 C-0.402345,11.6372025 0.947754,16.3281433 2.681613,18.9082025 C3.549105,20.17158 4.562946,21.5827975 5.889555,21.5327567 C7.187715,21.4779125 7.672554,20.6896342 9.239535,20.6896342 C10.791981,20.6896342 11.24685,21.5327567 12.600378,21.5009392 C13.993371,21.4779125 14.871006,20.2319517 15.708078,18.9566117 C16.3313702,18.0564115 16.8109922,17.0614939 17.129178,16.0087125 C15.4747288,15.2960036 14.3989644,13.6448464 14.397039,11.8152375 Z" />
                  <path d="M11.840499,4.1037425 C12.6000189,3.17509061 12.9742072,1.98146219 12.883599,0.776343333 C11.7232322,0.900473685 10.651378,1.46532306 9.881604,2.358345 C9.1214865,3.23943225 8.73641308,4.39213082 8.811198,5.56255333 C9.98711848,5.57488191 11.1036295,5.03720726 11.840499,4.1037425 Z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

AppleLogoIcon.defaultProps = defaultProps;

export default AppleLogoIcon;
